import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { AdminColors } from '../Admin/constants/adminColors';
import FontFamily from '../../constants/fonts';

// TODO: Build out People Reports once the People Hub backend and reporting data model are available.
const PeopleHubReports: React.FC = () => (
  <View style={styles.container}>
    <View style={styles.card}>
      <Text style={styles.title}>Reports</Text>
      <Text style={styles.copy}>People reporting and trend views will be available here once ready.</Text>
    </View>
  </View>
);

const styles = StyleSheet.create({
  container: { padding: 20 },
  card: {
    backgroundColor: AdminColors.bgSurface,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    padding: 24,
    gap: 8,
  },
  title: { fontFamily: FontFamily.bold, fontSize: 16, color: AdminColors.textPrimary },
  copy: { fontFamily: FontFamily.regular, fontSize: 13, color: AdminColors.textSecondary },
});

export default PeopleHubReports;
